import type { IdentityId, SchoolId } from "./navigation";

export type CriterionId = "nearCampus" | "convenience" | "quiet" | "quality";

export type PriorityScores = Record<CriterionId, number>;

export type UnitType = {
  id: string;
  name: string;
  area: string;
  priceText: string;
  priceJudgment: string;
  floorPlanImage?: string;
};

export type Community = {
  id: string;
  regionId: string;
  nameEn: string;
  type: string;
  description: string;
  image?: string;
  visited: boolean;
  visitNote: string;
  priorityScores: PriorityScores;
  unitTypes: UnitType[];
};

export type Region = {
  id: string;
  nameCn: string;
  nameEn: string;
  distance: string;
  type: string;
  priceText: string;
  rating?: number;
};

export type GuideData = {
  empathyText: string;
  reuseGuideFrom?: "solo";
  overviewText: string;
  overviewMap: {
    campus: string;
    regions: { id: string; nameCn: string }[];
  };
  regions: Region[];
  communities: Community[];
};

export type SchoolIdentity = {
  id: IdentityId;
  label: string;
  description: string;
  isFallback: boolean;
  guide?: GuideData;
};

export type SchoolContent = {
  id: SchoolId;
  nameCn: string;
  nameEn: string;
  area?: string;
  intro?: string;
  logo?: string;
  status: "online" | "coming";
  identities: SchoolIdentity[];
};

export type GlossaryEntry = {
  collapsedLabel: string;
  title: string;
  paragraphs: string[];
};

export type Glossary = {
  housingTypes: GlossaryEntry;
  roomTypes: GlossaryEntry;
};

export type AstraContentBundle = {
  _meta?: { note?: string; version?: string };
  glossary: Glossary;
  schools: SchoolContent[];
};

export const CRITERION_OPTIONS: {
  id: CriterionId;
  title: string;
  sub: string;
}[] = [
  { id: "nearCampus", title: "离学校近", sub: "走路或一站地铁到校" },
  { id: "convenience", title: "生活便利", sub: "楼下超市、外卖、奶茶都齐" },
  { id: "quiet", title: "安静舒适", sub: "环境安静、邻居简单" },
  { id: "quality", title: "房子本身好", sub: "户型大、采光好、家具新" },
];
